import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import BasicButton from "../BasicButton";
import WriteInput from "./WriteInput";

const InfoCell = ({ data }: stdObject) => {
  const style = typeof data === "object" && data.style ? data.style : null;
  const Icon = typeof data === "object" && data.Icon ? data.Icon : null;
  const writeByType = () => {
    switch (data.type) {
      case "src":
        return (
          <img
            className="prevent-select"
            src={data.src}
            alt={"svg"}
            style={{ width: 30 }}
          />
        );
      case "button":
        return (
          <BasicButton
            onClick={data.onClick ?? (() => {})}
            title={data.label}
            color={data.color}
            style={data.style ?? {}}
          />
        );
      case "icon":
        return (
          <Icon
            onClick={data.onClick}
            style={{ color: data.color ?? colors.black }}
          />
        );
      case "select":
      case "datetime-local":
      case "checkbox":
      case "date":
      case "text":
      case "number":
        return <WriteInput data={data} />;
      default:
        if (Array.isArray(data.text)) {
          return (
            <table>
              <tbody>
                {data.text.map((e: Array<string | number>, index: number) => (
                  <tr key={index}>
                    {e.map((v: string | number, idx: number) => (
                      <td key={idx} align={idx === 1 ? "right" : "left"}>
                        {v}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          );
        } else {
          return data.text;
        }
    }
  };
  return (
    <td
      style={{ padding: 5, ...style }}
      colSpan={typeof data === "object" && data.colSpan ? data.colSpan : 1}
    >
      {typeof data === "object" ? writeByType() : data}
    </td>
  );
};

export const writeTable = (
  table: any[],
  tableStyle: object,
  isList: boolean = false,
  headers: string[] = [],
) => {
  return (
    Array.isArray(table) && (
      <div style={{ padding: 5 }}>
        <div
          style={{
            maxHeight: 400,
            overflow: "auto",
            borderRadius: 5,
            border: `solid 2px ${colors.darkGrey}`,
            ...tableStyle,
          }}
        >
          <table style={{ width: "100%" }} cellSpacing={0}>
            {!!headers.length && (
              <thead>
                <tr className="header">
                  {headers.map((e: string, index: number) => (
                    <th
                      key={index}
                      className="noSelect"
                      style={{ backgroundColor: colors.grey }}
                    >
                      {e}
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {table.map(
                (e, index) =>
                  e && (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: isList
                          ? (e.bgColor ??
                            (index % 2 ? colors.lightGrey : colors.white))
                          : colors.white,
                        cursor: e.onClick ? "pointer" : "default",
                        ...e.style,
                      }}
                      onClick={e.onClick}
                    >
                      {e.data.map(
                        (o: string | number | object, idx: number) =>
                          o && <InfoCell key={idx} data={o} />,
                      )}
                    </tr>
                  ),
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  );
};
